import { useMemo } from "react"
import styles from './index.module.scss'
import Iconfont from '@utils/Iconfont';

export default function SelectionColorItem(props) {
    const {
        showName=true,
        showFavor=true,
        record,
        actived,
        favorite,
        onClick,
        onFavor,
    } = props

    const style = useMemo(() => {
        return {
            backgroundColor: actived ? "#FFFFFF" : record.color,
            borderColor: actived ? `var(--primary-color)` : record.color,
        }
    }, [actived, record])

    // 收藏/取消收藏
    const handleFavor = e => {
        e.stopPropagation()
        onFavor?.()
    }
    
    return (
        <div className={styles.ColorItem} onClick={() => onClick(record)}>
            <div className={styles.ColorItem_box} style={{...style}}>
                <div className={styles.ColorItem_box_inner} style={{background: record.color}}></div>
                {showFavor &&
                <div className={`${styles.TriggerItem} ${favorite && styles.favorited}`} onClick={handleFavor}>
                    <Iconfont type="icon-StarFilled" />
                    <Iconfont type="icon-StarFilled" />
                </div>}
            </div>
            {showName && <span className={styles.ColorItem_name}>{record.name}</span>}
        </div>
    )
}